import CollapseTable from './CollapseTable'
import ElementUtilities from './ElementUtilities'
import WidenImage from './WidenImage'

export default {
  CollapseTable,
  WidenImage,
  test: {
    ElementUtilities
  }
}